var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/utility-account-image.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"c-utility__svg c-utility__svg--account\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16.6\">\n\n\t<path d=\"M8,9.42A4.71,4.71,0,1,0,3.29,4.71,4.71,4.71,0,0,0,8,9.42ZM8,1A3.71,3.71,0,1,1,4.29,4.71,3.72,3.72,0,0,1,8,1Z\"/>\n    <path d=\"M16,16.1a9.61,9.61,0,0,0-3.48-7.57l-.62.79A8.56,8.56,0,0,1,15,15.6H1A8.56,8.56,0,0,1,4.1,9.32l-.62-.79A9.61,9.61,0,0,0,0,16.1v.5H16Z\"/>\n\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/utility-account-image.j2"] , dependencies)